"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healAll = healAll;
const heal_1 = require("./heal");
const walk_1 = require("./walk");
const types_1 = require("./types");
function healAll(inputs, fields) {
    const leaves = (0, walk_1.eachLeafField)(fields);
    const out = {};
    for (const f of leaves) {
        const uuid = (0, types_1.fieldKeyOf)(f);
        if (!uuid)
            continue;
        if (uuid in inputs) {
            out[uuid] = (0, heal_1.heal)(inputs[uuid], f);
        }
        else if (f.defaultValue !== undefined) {
            out[uuid] = f.defaultValue;
        }
    }
    return out;
}
